import { RefAttributes } from "react";
import { Link as RouterLink } from "react-router-dom";
import { GridActionsCellItemProps } from "@mui/x-data-grid-pro";
import ActionButton from "src/Pages/Company/Absences/ActionButton/ActionButton";

// "Nasty" workaround for typing problem, more info: https://github.com/mui/mui-x/issues/4654#issuecomment-1236369490"

type GridLinkActionProps = {
  to: string;
  bgColor: string;
  bgColorHover: string;
  label: string;
  color?: string;
  icon: React.JSX.Element;
  dataTestId?: string;
} & GridActionsCellItemProps &
  RefAttributes<HTMLButtonElement>;

const GridLinkAction = ({
  to,
  bgColor,
  bgColorHover,
  dataTestId,
  ...props
}: GridLinkActionProps) => (
  <RouterLink to={to}>
    <ActionButton
      label={props.label}
      bgColor={bgColor}
      bgColorHover={bgColorHover}
      color={props.color || "white"}
      dataTestId={dataTestId}
    >
      {props.icon}
    </ActionButton>
  </RouterLink>
);

export default GridLinkAction;
